import React, { useState, useEffect, lazy } from 'react';
import  { useNavigate } from 'react-router-dom'
import ModalAlertSendEmailSuccess from '../components/ModalAlertSendEmailSucces.js';
import ProgressWaiting from '../components/progress-wating.js';
import { api } from '../utils/endpoint.js'

const HeaderComponent = lazy(() => import('../components/Header.js'));
const FooterComponent  = lazy(() => import('../components/Footer'));

const imgBanner = 'https://cdn.data.thaivivat.co.th/web/internal-project/motor-claim/main/img_banner.png'
const iconInform = 'https://cdn.data.thaivivat.co.th/web/internal-project/motor-claim/main/ic_inform.svg'
const iconCheckStatus = 'https://cdn.data.thaivivat.co.th/web/internal-project/motor-claim/main/ic_check_status.svg'
const iconNext = 'https://cdn.data.thaivivat.co.th/web/internal-project/motor-claim/main/ic_next.png'
const iconDown = 'https://cdn.data.thaivivat.co.th/web/internal-project/motor-claim/main/ic_down.svg'
const iconUp = 'https://cdn.data.thaivivat.co.th/web/internal-project/motor-claim/main/ic_up.svg'
const iconTel = 'https://cdn.data.thaivivat.co.th/web/internal-project/motor-claim/main/ic_tel.svg'
const iconFax = 'https://cdn.data.thaivivat.co.th/web/internal-project/motor-claim/main/ic_fax.svg'
const iconEmail = 'https://cdn.data.thaivivat.co.th/web/internal-project/motor-claim/main/ic_email.svg'
const iconLocation = 'https://cdn.data.thaivivat.co.th/web/internal-project/motor-claim/main/ic_location.svg'

function MainPage() {

  const navigate = useNavigate();

  const [isShowAlertEmail, setIsShowAlertEmail] = useState(false)
  const [isEmailSuccess, setIsEmailSuccess] = useState(true)

  const [isValid, setIsValid] = useState(false)

  const [grayDay, setGrayDay] = useState(new Date() > new Date('2025-11-10') ? '':'grayscale(60%)')
  
  function confirmClick () {
    setIsShowAlertEmail(false)
  }

  const [ isShowMenu, setIsShowMenu ] = useState(
    {
      menu_1 : false,
      menu_2 : false,
      menu_3 : false,
      menu_4 : false,
      menu_5 : false,
      menu_6 : false,
      menu_7 : false,
      menu_8 : false,
      menu_9 : false,
      menu_10 : false,
      menu_11 : false,
      menu_12 : false,
      menu_13 : false,
      menu_14 : false,
      menu_15 : false,
      menu_16 : false,
    }
  )

  function changeStateCondition( menuIndex ){
    switch(menuIndex){
      case 1: 
      setIsShowMenu({
        ...isShowMenu,
        menu_1 : !isShowMenu.menu_1
      })
      break;
      case 2: 
      setIsShowMenu({
        ...isShowMenu,
        menu_2 : !isShowMenu.menu_2
      })
      break;
      case 3: 
      setIsShowMenu({
        ...isShowMenu,
        menu_3 : !isShowMenu.menu_3
      })
      break;
      case 4: 
      setIsShowMenu({
        ...isShowMenu,
        menu_4 : !isShowMenu.menu_4
      })
      break;
      case 5: 
      setIsShowMenu({
        ...isShowMenu,
        menu_5 : !isShowMenu.menu_5
      })
      break;
      case 6: 
      setIsShowMenu({
        ...isShowMenu,
        menu_6 : !isShowMenu.menu_6
      })
      break;
      case 7: 
      setIsShowMenu({
        ...isShowMenu,
        menu_7 : !isShowMenu.menu_7
      })
      break;
      case 8: 
      setIsShowMenu({
        ...isShowMenu,
        menu_8 : !isShowMenu.menu_8
      })
      break;
      case 9: 
      setIsShowMenu({
        ...isShowMenu,
        menu_9 : !isShowMenu.menu_9
      })
      break;
      case 10: 
      setIsShowMenu({
        ...isShowMenu,
        menu_10 : !isShowMenu.menu_10
      })
      break;
      case 11: 
      setIsShowMenu({
        ...isShowMenu,
        menu_11 : !isShowMenu.menu_11
      })
      break;
      case 12: 
      setIsShowMenu({
        ...isShowMenu,
        menu_12 : !isShowMenu.menu_12
      })
      break;
      case 13: 
      setIsShowMenu({
        ...isShowMenu,
        menu_13 : !isShowMenu.menu_13
      })
      break;
      case 14: 
      setIsShowMenu({
        ...isShowMenu,
        menu_14 : !isShowMenu.menu_14
      })
      break;
      case 15: 
      setIsShowMenu({
        ...isShowMenu,
        menu_15 : !isShowMenu.menu_15
      })
      break;
      case 16: 
      setIsShowMenu({
        ...isShowMenu,
        menu_16 : !isShowMenu.menu_16
      })
      break;
    }
  }

  const [ customerName, setCustomerName ] = useState("")
  const [ customerEmail, setCustomerEmail ] = useState("")
  const [ customerTel, setCustomerTel ] = useState("")
  const [ customerMessage, setCustomerMessage ] = useState("")

  useEffect(() => {
    const pictures = [
      imgBanner
    ]
    var preloadedData = pictures.map((picture) => {
      const img = new Image();
      img.src = picture.fileName;
      return img
  });
    window.scrollTo(0, 0)
  }, [])

  useEffect(() => {
    if(
      customerName !== "" 
      && customerMessage !== ""
      && customerTel !== ""
      && customerTel.substring(0, 1) === '0' 
      && ( customerTel.length === 10 || customerTel.length === 9 )
    ){
      setIsValid(true)
    } else {
      setIsValid(false)
    }
  }, [ customerName, customerTel, customerMessage ])


  function validateString( event ){
    if (!/[.A-Za-zก-ฮ-่-้-๊-๋-็ะ-ูเ-ไ-์ 0-9@_]/.test(event.nativeEvent.data) && (event.nativeEvent.data !== null) && (event.nativeEvent.data !== undefined) ) {
      return false
    }
    return true
  }


  function validateEmail( event ){
    if (!/[.A-Za-z0-9@_]/.test(event.nativeEvent.data) && (event.nativeEvent.data !== null) && (event.nativeEvent.data !== undefined) ) {
      return false
    }
    return true
  }

  function validateNumber( event ){
    if (!/[0-9]/.test(event.nativeEvent.data) && (event.nativeEvent.data !== null) && (event.nativeEvent.data !== undefined) ) {
      return false
    }
    return true
  }

  function onChangeText( event, setterInput ){
    if (!validateString(event)) {
      event.preventDefault();
    }
    else if( event.nativeEvent.data === undefined){
      //Clear
      setterInput("")
    }
    else{
      //Set Value
      setterInput(event.target.value)
    }
  }


  const regExTel = ( data ) => {
    if (!/(^[0]{0,1}$)|(^[0]{1}[0-9]{1,9}$)/.test(data) && 
        (data !== null) && 
        (data !== undefined) 
      ) {
      return false
    }
    return true
  }
  const validateTel = (event, setter) =>  {
    isValidateFull(event, setter, regExTel);
  }

  const isClear = ( event ) => {
    if ( event.nativeEvent.data === undefined) {
      return true;
    }
    return false;
  }
  const isValidateFull = (event, setter, method) => {
    if (isClear(event)) {
      setter("")
    } else {
      if(!method(event.target.value)){
        event.preventDefault();
      } else {
        //Set Value
        setter(event.target.value)
      }
    }
  }

  function onChangeNumber( event, setterInput ){

    validateTel(event, setterInput)
    // if (!validateNumber(event)) {
    //   event.preventDefault();
    // }
    // else if( event.nativeEvent.data === undefined){
    //   //Clear
    //   setterInput("")
    // }
    // else{
    //   //Set Value
    //   setterInput(event.target.value)
    // }
  }

  function onChangeEmail( event, setterInput ){
    if (!validateEmail(event)) {
      event.preventDefault();
    }
    else if( event.nativeEvent.data === undefined){
      //Clear
      setterInput("")
    }
    else{
      //Set Value
      setterInput(event.target.value)
    }
  }

  function submit(){
    callApiSendEmail()
  }

  async function callApiSendEmail( ) {
    

    const requestOptions = {
      method: 'POST',  
      headers: {
        'Content-Type':'application/json'
      },
      body: JSON.stringify(
        {
          "fullname": customerName,
          "email": customerEmail,
          "note": customerMessage,
          "tel": customerTel
      }
      )
    };
    fetch(api.email.contactUs(),requestOptions)
    .then(response => response.json())
    .then(data => onSuccessCallApiSendEmail(data), (error) => {
      if (error) {
        onFailCallApiSendEmail(error )
      }
    });
  }
  function onSuccessCallApiSendEmail(data) {

    setCustomerEmail('')
    setCustomerName('')
    setCustomerTel('')
    setCustomerMessage('')

    setIsEmailSuccess(true)
    setIsShowAlertEmail(true)
  }
  function onFailCallApiSendEmail(error) {
    setIsEmailSuccess(false)
    setIsShowAlertEmail(true)
  }

  function gotoCheckStatus(){
    navigate("/track")
  }

  function gotoInform(){
    navigate("/inform")
  }

  return (
  <div className="w-full bg-white font-prompt" style={{filter:grayDay}}>
      <div className="flex flex-wrap w-full bg-white font-prompt">

        <HeaderComponent></HeaderComponent>
        
        { /* Banner */}
        <div className='flex flex-wrap  w-full bg-green-500 px-4'>
          <div className='flex flex-wrap w-full lg:w-1092 lg:mx-auto'>
            <div className='flex-wrap w-full md:w-1/2'>
              <div className='w-full  mt-6 md:mt-20'>
                <span className='w-full text-white text-[32px] md:text-[40px] font-medium leading-[44px] md:leading-[56px]'>บริการช่วยเหลือด้านการเรียกค่าสินไหมทดแทน</span>
              </div>
              <div className='w-full mt-2 md:mt-4 md:mb-20'>
                <span className='w-full text-white text-lg font-normal leading-normal '>สำหรับประกันภัยรถยนต์ กรณีอู่นอกสัญญา รถประกัน หรือรถคู่กรณี</span>
              </div>             
              
            </div>
            <div className='w-full md:w-1/2 justify-center md:justify-end items-end flex mt-20'>
              <img src={imgBanner} alt="img-banner"  className=' md:w-[382px] md:h-[235px]'/>
            </div>
          </div>
        </div>



        { /* Menu status */}
        <div className='flex flex-wrap w-full  lg:w-1092  md:h-[364px] lg:mx-auto bg-white py-16 md:py-[96px] justify-center'>
            <div className='flex flex-wrap w-full max-w-[904px]'>

              <div className='flex w-full md:w-1/2'>
                <div className='grow flex-wrap w-full pr-[24px]'>
                  <div className='flex w-full justify-center'>
                    <img src={iconInform} alt="icon-inform" />
                  </div>
                  <div className='flex w-full justify-center mt-6'>
                    <span className='text-xl font-medium leading-7'>เรียกร้องสินไหม</span>
                  </div>
                  <div className='flex w-full justify-center mt-1'>
                    <span className='flex md:hidden text-lg font-normal leading-6 text-grey-600 text-center'>สำหรับประกันภัยรถยนต์</span>
                    <span className='hidden md:flex text-lg font-normal leading-6 text-grey-600 text-center'>สำหรับประกันภัยรถยนต์</span>
                  </div>
                  <div className='flex w-full justify-center  mt-6'>
                    <div className='flex'>
                      <button onClick={gotoInform} className='text-base font-normal leading-5 text-green-500' data-testid='submitDoc-online-button'>ส่งเอกสารคุมราคาออนไลน์</button>
                    </div>
                    <div className='flex'>
                      <img src={iconNext} alt="icon-next" className='w-3 h-3 my-auto' />
                    </div>
                  </div>
                </div>

                <div className='flex-none hidden md:flex flex-wrap'>
                  <div className='flex'>
                    <div className='flex border-r border-r-grey-500 h-[80px] my-auto'></div>
                  </div>
                </div>

              </div>

              <div className='flex-wrap w-full md:w-1/2 mt-12 md:mt-0  md:pl-[24px]'>
                <div className='flex w-full justify-center'>
                  <img src={iconCheckStatus} alt="icon-inform" />
                </div>
                <div className='flex w-full justify-center mt-6'>
                  <span className='text-xl font-medium leading-7'>ติดตามสถานะ</span>
                </div>
                <div className='flex w-full justify-center mt-1'>
                  <span className='flex md:hidden text-lg font-normal leading-6 text-grey-600 text-center'>ดูข้อมูลสถานะการเรียกร้อง<br/>สินไหมทดแทน</span>
                  <span className='hidden md:flex text-lg font-normal leading-6 text-grey-600 text-center'>ดูข้อมูลสถานะการเรียกร้องสินไหมทดแทน</span>
                </div>
                <div className='flex w-full justify-center  mt-6'>
                  <div className='flex'>
                    <button onClick={gotoCheckStatus} className='text-base font-normal leading-5 text-green-500' data-testid='followStatus-button' >ตรวจสอบผล </button>
                  </div>
                  <div className='flex'>
                    <img src={iconNext} alt="icon-next" className='w-3 h-3 my-auto' />
                  </div>
                </div>

              </div>

            </div>
        </div>


        { /* Condition */}
        <div className='flex flex-wrap w-full justify-center'>
          <div className='flex flex-wrap w-full lg:w-1092 lg:mx-auto bg-white px-4 py-16 md:py-[96px] justify-center'>
              <div className='flex flex-wrap w-full '>
                
                <div className='flex flex-wrap w-full justify-center'>
                  <span className='flex md:hidden text-2xl md:text-[32px] font-medium leading-8 md:leading-[44px] text-center'>คำแนะนำเรียกร้องค่าสินไหมทดแทน<br/>อู่นอกสัญญา</span>
                  <span className='hidden md:flex text-2xl md:text-[32px] font-medium leading-8 md:leading-[44px] text-center'>คำแนะนำเรียกร้องค่าสินไหมทดแทน อู่นอกสัญญา</span>
                </div>
              </div>

              <div className='flex flex-wrap w-full '>


                <div className='flex flex-wrap w-full mt-10 md:mt-16'>
                  <span className='flex text-xl md:text-2xl font-medium leading-7 md:leading-8'>เอกสารสำหรับการเรียกร้องค่าสินไหมทดแทน</span>
                </div>

                <div className='flex flex-wrap w-full mt-6'>
                  <span className='flex text-lg md:text-xl font-medium leading-6 md:leading-7'>1. กรณีรถประกัน</span>
                </div>

                <div className='flex flex-wrap  w-full mt-6'>

  

                  <div className='flex flex-wrap  w-full mt-6'>

                    <div data-testid='insuredDoc-labor-autoPart-text' className='flex flex-wrap w-full border-b-[0.5px] border-b-grey-500 pb-6'>
                      { /* Header */ }
                      <div className='flex w-full'>
                        <div className='grow w-full'>
                          <span className='flex text-lg font-normal leading-6'>ค่าแรง ค่าอะไหล่</span>
                        </div>
                        <div className='flex-none'>
                          <button data-testid='insuredDoc-labor-autoPart-button' onClick={ (e)=>{ changeStateCondition(1) } } ><img src={ (isShowMenu.menu_1)? iconUp :  iconDown} alt="icon-span" /></button>
                        </div>
                      </div>
                      { /* Content */ }
                      <div className={((isShowMenu.menu_1)? ' flex ' : ' hidden ') + ' flex-wrap w-full mt-6 font-sarabun text-grey-600 text-base font-normal md:text-medium leading-6'}>
                        <ol className='w-full list-decimal  px-4'>
                          <li>ต้นฉบับหลักฐานรับผิดชอบความเสียหายรถประกัน หรือ ใบเคลม</li>
                          <li>ใบเสนอราคา</li>
                          <li>ภาพถ่าย ความเสียหายเบื้องต้น ก่อนจัดซ่อม</li>
                          <li>สำเนาบัตรประชาชนผู้เอาประกันภัย พร้อมลงชื่อ รับรองสำเนาถูกต้อง</li>
                          <li>สำเนาหนังสือรับรองการจดทะเบียน พร้อมสำเนาบัตรประชาชนกรรมการ พร้อมประทับตรา (กรณีเป็นนิติบุคคล)</li>
                          <li>ต้นฉบับคู่มือจดทะเบียนรถ หรือสำเนาพร้อมรายการจดทะเบียนเปลี่ยนแปลง และรายการต่อภาษีปีปัจจุบัน พร้อมรับรองสำเนาถูกต้อง (ถ้ามี)</li>
                        </ol>
                        <span className='mt-8  font-medium'>เอกสารเพิ่มเติมกรณีมอบอำนาจจากผู้เอาประกันมาติดต่อ</span>
                        <ol className='w-full list-disc px-4'>
                          <li  className=''>หนังสือมอบอำนาจ ติดอากรแสตมป์ 30 บาท</li>
                          <li  className=''>สำเนาบัตรประจำตัวประชาชนของผู้เอาประกันภัยและผู้รับมอบอำนาจ พร้อมลงชื่อรับรองสำเนาถูกต้อง</li>
                        </ol>
                      
                      </div>
                    </div>

                  </div>

                  <div className='flex flex-wrap  w-full mt-6'>

                    <div data-testid='insuredDoc-labor-autoPart-towCar-text' className='flex flex-wrap w-full border-b-[0.5px] border-b-grey-500 pb-6'>
                      { /* Header */ }
                      <div className='flex w-full'>
                        <div className='grow w-full'>
                          <span className='flex text-lg font-normal leading-6'>ค่าแรง ค่าอะไหล่ ค่ารถยก</span>
                        </div>
                        <div className='flex-none'>
                          <button data-testid='insuredDoc-labor-autoPart-towCar-button' onClick={ (e)=>{ changeStateCondition(2) } } ><img src={ (isShowMenu.menu_2)? iconUp :  iconDown} alt="icon-span" /></button>
                        </div>
                      </div>
                      { /* Content */ }
                      <div className={((isShowMenu.menu_2)? ' flex ' : ' hidden ') + ' flex-wrap w-full mt-6 font-sarabun text-grey-600 text-base font-normal md:text-medium leading-6'}>
                        <ol className='w-full list-decimal  px-4'>
                          <li>ต้นฉบับหลักฐานรับผิดชอบความเสียหายรถประกัน หรือ ใบเคลม</li>
                          <li>ใบเสนอราคา</li>
                          <li>ต้นฉบับใบเสร็จรับเงิน / บิลเงินสดค่ารถยก</li>
                          <li>ภาพถ่าย ความเสียหายเบื้องต้น ก่อนจัดซ่อม</li>
                          <li>สำเนาบัตรประชาชนผู้เอาประกันภัย พร้อมลงชื่อ รับรองสำเนาถูกต้อง</li>
                          <li>สำเนาหนังสือรับรองการจดทะเบียน พร้อมสำเนาบัตรประชาชนกรรมการ พร้อมประทับตรา (กรณีเป็นนิติบุคคล)</li>
                          <li>ต้นฉบับคู่มือจดทะเบียนรถ หรือสำเนาพร้อมรายการจดทะเบียนเปลี่ยนแปลง และรายการต่อภาษีปีปัจจุบัน พร้อมรับรองสำเนาถูกต้อง (ถ้ามี)</li>
                        </ol>
                        <span className='mt-8  font-medium'>เอกสารเพิ่มเติมกรณีมอบอำนาจจากผู้เอาประกันมาติดต่อ</span>
                        <ol className='w-full list-disc px-4'>
                          <li className=''>หนังสือมอบอำนาจ ติดอากรแสตมป์ 30 บาท</li>
                          <li className=''>สำเนาบัตรประจำตัวประชาชนของผู้เอาประกันภัยและผู้รับมอบอำนาจ พร้อมลงชื่อรับรองสำเนาถูกต้อง</li>
                        </ol>
                      
                      </div>
                    </div>

                  </div>


                  <div className='flex flex-wrap  w-full mt-6'>

                    <div data-testid='insuredDoc-towCar-text' className='flex flex-wrap w-full border-b-[0.5px] border-b-grey-500 pb-6'>
                      { /* Header */ }
                      <div className='flex w-full'>
                        <div className='grow w-full'>
                          <span className='flex text-lg font-normal leading-6'>ค่ารถยก</span>
                        </div>
                        <div className='flex-none'>
                          <button data-testid='insuredDoc-towCar-button' onClick={ (e)=>{ changeStateCondition(3) } } ><img src={ (isShowMenu.menu_3)? iconUp :  iconDown} alt="icon-span" /></button>
                        </div>
                      </div>
                      { /* Content */ }
                      <div className={((isShowMenu.menu_3)? ' flex ' : ' hidden ') + ' flex-wrap w-full mt-6 font-sarabun text-grey-600 text-base font-normal md:text-medium leading-6'}>
                        <ol className='w-full list-decimal  px-4'>
                          <li>สำเนาหลักฐานรับผิดชอบความเสียหายรถประกัน หรือ ใบเคลม</li>
                          <li>ใบเสนอราคา</li>
                          <li>ภาพถ่ายขณะยกรถ</li>
                          <li>สำเนาบัตรประชาชนผู้เอาประกันภัย พร้อมลงชื่อ รับรองสำเนาถูกต้อง</li>
                          <li>สำเนาหนังสือรับรองการจดทะเบียน พร้อมสำเนาบัตรประชาชนกรรมการ พร้อมประทับตรา (กรณีเป็นนิติบุคคล)</li>
                          <li>ต้นฉบับคู่มือจดทะเบียนรถ หรือสำเนาพร้อมรายการจดทะเบียนเปลี่ยนแปลง และรายการต่อภาษีปีปัจจุบัน พร้อมรับรองสำเนาถูกต้อง (ถ้ามี)</li>
                        </ol>
                        <span className='mt-8  font-medium'>เอกสารเพิ่มเติมกรณีมอบอำนาจจากผู้เอาประกันมาติดต่อ</span>
                        <ol className='w-full list-disc px-4'>
                          <li className=''>หนังสือมอบอำนาจ ติดอากรแสตมป์ 30 บาท</li>
                          <li className=''>สำเนาบัตรประจำตัวประชาชนของผู้เอาประกันภัยและผู้รับมอบอำนาจ พร้อมลงชื่อรับรองสำเนาถูกต้อง</li>
                        </ol>
                      
                      </div>
                    </div>

                  </div>         

                  <div className='flex flex-wrap  w-full mt-6'>

                    <div data-testid='insuredDoc-tire-alloyWheel-text' className='flex flex-wrap w-full border-b-[0.5px] border-b-grey-500 pb-6'>
                      { /* Header */ }
                      <div className='flex w-full'>
                        <div className='grow w-full'>
                          <span className='flex text-lg font-normal leading-6'>ค่ายาง ค่าล้อแม็ก</span>
                        </div>
                        <div className='flex-none'>
                          <button data-testid='insuredDoc-tire-alloyWheel-button' onClick={ (e)=>{ changeStateCondition(4) } } ><img src={ (isShowMenu.menu_4)? iconUp :  iconDown} alt="icon-span" /></button>
                        </div>
                      </div>
                      { /* Content */ }
                      <div className={((isShowMenu.menu_4)? ' flex ' : ' hidden ') + ' flex-wrap w-full mt-6 font-sarabun text-grey-600 text-base font-normal md:text-medium leading-6'}>
                        <ol className='w-full list-decimal  px-4'>
                          <li>ต้นฉบับหลักฐานรับผิดชอบความเสียหายรถประกัน หรือ ใบเคลม</li>
                          <li>ใบเสนอราคา</li>
                          <li>ภาพถ่าย ความเสียหายเบื้องต้น ก่อนจัดซ่อม</li>
                          <li>สำเนาบัตรประชาชนผู้เอาประกันภัย พร้อมลงชื่อ รับรองสำเนาถูกต้อง</li>
                          <li>สำเนาหนังสือรับรองการจดทะเบียน พร้อมสำเนาบัตรประชาชนกรรมการ พร้อมประทับตรา (กรณีเป็นนิติบุคคล)</li>
                          <li>ต้นฉบับคู่มือจดทะเบียนรถ หรือสำเนาพร้อมรายการจดทะเบียนเปลี่ยนแปลง และรายการต่อภาษีปีปัจจุบัน พร้อมรับรองสำเนาถูกต้อง (ถ้ามี)</li>
                        </ol>
                        <span className='mt-8  font-medium'>เอกสารเพิ่มเติมกรณีมอบอำนาจจากผู้เอาประกันมาติดต่อ</span>
                        <ol className='w-full list-disc px-4'>
                          <li className=''>หนังสือมอบอำนาจ ติดอากรแสตมป์ 30 บาท</li>
                          <li className=''>สำเนาบัตรประจำตัวประชาชนของผู้เอาประกันภัยและผู้รับมอบอำนาจ พร้อมลงชื่อรับรองสำเนาถูกต้อง</li>
                        </ol>
                      
                      </div>
                    </div>

                  </div>                           

                  <div className='flex flex-wrap  w-full mt-6'>

                    <div data-testid='insuredDoc-glass-film-text' className='flex flex-wrap w-full border-b-[0.5px] border-b-grey-500 pb-6'>
                      { /* Header */ }
                      <div className='flex w-full'>
                        <div className='grow w-full'>
                          <span className='flex text-lg font-normal leading-6'>ค่ากระจก ค่าฟิล์ม</span>
                        </div>
                        <div className='flex-none'>
                          <button data-testid='insuredDoc-glass-film-button' onClick={ (e)=>{ changeStateCondition(5) } } ><img src={ (isShowMenu.menu_5)? iconUp :  iconDown} alt="icon-span" /></button>
                        </div>
                      </div>
                      { /* Content */ }
                      <div className={((isShowMenu.menu_5)? ' flex ' : ' hidden ') + ' flex-wrap w-full mt-6 font-sarabun text-grey-600 text-base font-normal md:text-medium leading-6'}>
                        <ol className='w-full list-decimal  px-4'>
                          <li>ต้นฉบับหลักฐานรับผิดชอบความเสียหายรถประกัน หรือ ใบเคลม</li>
                          <li>ใบเสนอราคา</li>
                          <li>ภาพถ่าย ความเสียหายเบื้องต้น ก่อนจัดซ่อม</li>
                          <li>สำเนาบัตรประชาชนผู้เอาประกันภัย พร้อมลงชื่อ รับรองสำเนาถูกต้อง</li>
                          <li>สำเนาหนังสือรับรองการจดทะเบียน พร้อมสำเนาบัตรประชาชนกรรมการ พร้อมประทับตรา (กรณีเป็นนิติบุคคล)</li>
                          <li>ต้นฉบับคู่มือจดทะเบียนรถ หรือสำเนาพร้อมรายการจดทะเบียนเปลี่ยนแปลง และรายการต่อภาษีปีปัจจุบัน พร้อมรับรองสำเนาถูกต้อง (ถ้ามี)</li>
                        </ol>
                        <span className='mt-8  font-medium'>เอกสารเพิ่มเติมกรณีมอบอำนาจจากผู้เอาประกันมาติดต่อ</span>
                        <ol className='w-full list-disc px-4'>
                          <li className=''>หนังสือมอบอำนาจ ติดอากรแสตมป์ 30 บาท</li>
                          <li className=''>สำเนาบัตรประจำตัวประชาชนของผู้เอาประกันภัยและผู้รับมอบอำนาจ พร้อมลงชื่อรับรองสำเนาถูกต้อง</li>
                        </ol>
                      
                      </div>
                    </div>

                  </div>   

                </div>


                <div className='flex flex-wrap w-full mt-6'>
                  <span className='flex text-lg md:text-xl font-medium leading-6 md:leading-7'>2. กรณีรถคู่กรณี</span>
                </div>

                <div className='flex flex-wrap  w-full mt-6'>

                  <div data-testid='contestantDoc-labor-autoPart-text' className='flex flex-wrap w-full border-b-[0.5px] border-b-grey-500 pb-6'>
                    { /* Header */ }
                    <div className='flex w-full'>
                      <div className='grow w-full'>
                        <span className='flex text-lg font-normal leading-6'>ค่าแรง ค่าอะไหล่</span>
                      </div>
                      <div className='flex-none'>
                        <button data-testid='contestantDoc-labor-autoPart-button' onClick={ (e)=>{ changeStateCondition(6) } } ><img src={ (isShowMenu.menu_6)? iconUp :  iconDown} alt="icon-span" /></button>
                      </div>
                    </div>
                    { /* Content */ }
                    <div className={((isShowMenu.menu_6)? ' flex ' : ' hidden ') + ' flex-wrap w-full mt-6 font-sarabun text-grey-600 text-base font-normal md:text-medium leading-6'}>
                      <ol className='w-full list-decimal  px-4'>
                        <li>ต้นฉบับหลักฐานรับผิดชอบความเสียหายรถคู่กรณี หรือ ใบเคลม</li>
                        <li>ใบเสนอราคา หรือใบเสร็จรับเงิน (บริษัท จะพิจารณาคุมราคาตามมาตรฐาน)</li>
                        <li>ภาพถ่ายความเสียหาย</li>
                        <li>ต้นฉบับคู่มือจดทะเบียนรถ หรือ สำเนา พร้อมรายการจดทะเบียนเปลี่ยนแปลง และ รายการต่อภาษีปีปัจจุบัน พร้อมรับรองสำเนาถูกต้อง</li>
                        <li>สำเนากรมธรรม์ พรบ. (ถ้ามี)</li>
                        <li>สำเนากรมธรรม์ประกันภัยภาคสมัครใจ (ถ้ามี)</li>
                        <li>สำเนาบัตรประชาชนเจ้าของรถคู่กรณี พร้อมลงชื่อ รับรองสำเนาถูกต้อง</li>
                        <li>สำเนาหนังสือรับรองการจดทะเบียน พร้อมสำเนาบัตรประชาชนกรรมการ พร้อมประทับตรา (กรณีเป็นนิติบุคคล)</li>
                      </ol>
                      <span className='mt-8  font-medium'>เอกสารเพิ่มเติมกรณีมอบอำนาจจากเจ้าของรถคู่กรณีมาติดต่อ</span>
                      <ol className='w-full list-disc px-4'>
                        <li className=''>หนังสือมอบอำนาจ ติดอากรแสตมป์ 30 บาท</li>
                        <li className=''>สำเนาบัตรประจำตัวประชาชนของผู้เอาประกันภัยและผู้รับมอบอำนาจ พร้อมลงชื่อรับรองสำเนาถูกต้อง</li>
                      </ol>
                    
                    </div>
                  </div>

                </div>

                <div className='flex flex-wrap  w-full mt-6'>

                  <div data-testid='contestantDoc-labor-autoPart-loseBenefits-text' className='flex flex-wrap w-full border-b-[0.5px] border-b-grey-500 pb-6'>
                    { /* Header */ }
                    <div className='flex w-full'>
                      <div className='grow w-full'>
                        <span className='flex text-lg font-normal leading-6'>ค่าซ่อม (ค่าแรง,ค่าอะไหล่) และค่าขาดผลประโยชน์</span>
                      </div>
                      <div className='flex-none'>
                        <button data-testid='contestantDoc-labor-autoPart-loseBenefits-button' onClick={ (e)=>{ changeStateCondition(7) } } ><img src={ (isShowMenu.menu_7)? iconUp :  iconDown} alt="icon-span" /></button>
                      </div>
                    </div>
                    { /* Content */ }
                    <div className={((isShowMenu.menu_7)? ' flex ' : ' hidden ') + ' flex-wrap w-full mt-6 font-sarabun text-grey-600 text-base font-normal md:text-medium leading-6'}>
                      <ol className='w-full list-decimal  px-4'>
                        <li>ต้นฉบับหลักฐานรับผิดชอบความเสียหายรถคู่กรณี หรือ ใบเคลม</li>
                        <li>ใบเสนอราคา หรือใบเสร็จรับเงิน (บริษัท จะพิจารณาคุมราคาตามมาตรฐาน)</li>
                        <li>ภาพถ่ายความเสียหาย</li>
                        <li>ต้นฉบับคู่มือจดทะเบียนรถ หรือ สำเนา พร้อมรายการจดทะเบียนเปลี่ยนแปลง และ รายการต่อภาษีปีปัจจุบัน พร้อมรับรองสำเนาถูกต้อง</li>
                        <li>สำเนากรมธรรม์ พรบ. (ถ้ามี)</li>
                        <li>สำเนากรมธรรม์ประกันภัยภาคสมัครใจ (ถ้ามี)</li>
                        <li>สำเนาบัตรประชาชนเจ้าของรถคู่กรณี พร้อมลงชื่อ รับรองสำเนาถูกต้อง</li>
                        <li>สำเนาหนังสือรับรองการจดทะเบียน พร้อมสำเนาบัตรประชาชนกรรมการ พร้อมประทับตรา (กรณีเป็นนิติบุคคล)</li>
                      </ol>
                      <span className='mt-8  font-medium'>เอกสารเพิ่มเติมกรณีมอบอำนาจจากเจ้าของรถคู่กรณีมาติดต่อ</span>
                      <ol className='w-full list-disc px-4'>
                        <li className=''>หนังสือมอบอำนาจ ติดอากรแสตมป์ 30 บาท</li>
                        <li className=''>สำเนาบัตรประจำตัวประชาชนของผู้เอาประกันภัยและผู้รับมอบอำนาจ พร้อมลงชื่อรับรองสำเนาถูกต้อง</li>
                      </ol>
                    
                    </div>
                  </div>

                </div>

                <div className='flex flex-wrap  w-full mt-6'>

                  <div data-testid='contestantDoc-labor-autoPart-loseBenefits-towCar-text' className='flex flex-wrap w-full border-b-[0.5px] border-b-grey-500 pb-6'>
                    { /* Header */ }
                    <div className='flex w-full'>
                      <div className='grow w-full'>
                        <span className='flex text-lg font-normal leading-6'>ค่าแรง ค่าอะไหล่ ค่าขาดผลประโยชน์ ค่ารถยก</span>
                      </div>
                      <div className='flex-none'>
                        <button data-testid='contestantDoc-labor-autoPart-loseBenefits-towCar-button' onClick={ (e)=>{ changeStateCondition(8) } } ><img src={ (isShowMenu.menu_8)? iconUp :  iconDown} alt="icon-span" /></button>
                      </div>
                    </div>
                    { /* Content */ }
                    <div className={((isShowMenu.menu_8)? ' flex ' : ' hidden ') + ' flex-wrap w-full mt-6 font-sarabun text-grey-600 text-base font-normal md:text-medium leading-6'}>
                      <ol className='w-full list-decimal  px-4'>
                        <li>ต้นฉบับหลักฐานรับผิดชอบความเสียหายรถคู่กรณี หรือ ใบเคลม</li>
                        <li>ใบเสนอราคา หรือใบเสร็จรับเงิน (บริษัท จะพิจารณาคุมราคาตามมาตรฐาน)</li>
                        <li>ต้นฉบับใบเสร็จค่ารถยก / บิลเงินสดค่ารถยก</li>
                        <li>ภาพถ่ายความเสียหาย</li>
                        <li>ต้นฉบับคู่มือจดทะเบียนรถ หรือ สำเนา พร้อมรายการจดทะเบียนเปลี่ยนแปลง และ รายการต่อภาษีปีปัจจุบัน พร้อมรับรองสำเนาถูกต้อง</li>
                        <li>สำเนากรมธรรม์ พรบ. (ถ้ามี)</li>
                        <li>สำเนากรมธรรม์ประกันภัยภาคสมัครใจ (ถ้ามี)</li>
                        <li>สำเนาบัตรประชาชนเจ้าของรถคู่กรณี พร้อมลงชื่อ รับรองสำเนาถูกต้อง</li>
                        <li>สำเนาหนังสือรับรองการจดทะเบียน พร้อมสำเนาบัตรประชาชนกรรมการ พร้อมประทับตรา (กรณีเป็นนิติบุคคล)</li>
                      </ol>
                      <span className='mt-8  font-medium'>เอกสารเพิ่มเติมกรณีมอบอำนาจจากเจ้าของรถคู่กรณีมาติดต่อ</span>
                      <ol className='w-full list-disc px-4'>
                        <li className=''>หนังสือมอบอำนาจ ติดอากรแสตมป์ 30 บาท</li>
                        <li className=''>สำเนาบัตรประจำตัวประชาชนของผู้เอาประกันภัยและผู้รับมอบอำนาจ พร้อมลงชื่อรับรองสำเนาถูกต้อง</li>
                      </ol>
                    
                    </div>
                  </div>

                </div>

                <div className='flex flex-wrap  w-full mt-6'>

                  <div data-testid='contestantDoc-loseBenefits-text' className='flex flex-wrap w-full border-b-[0.5px] border-b-grey-500 pb-6'>
                    { /* Header */ }
                    <div className='flex w-full'>
                      <div className='grow w-full'>
                        <span className='flex text-lg font-normal leading-6'>ค่าขาดผลประโยชน์</span>
                      </div>
                      <div className='flex-none'>
                        <button data-testid='contestantDoc-loseBenefits-button' onClick={ (e)=>{ changeStateCondition(9) } } ><img src={ (isShowMenu.menu_9)? iconUp :  iconDown} alt="icon-span" /></button>
                      </div>
                    </div>
                    { /* Content */ }
                    <div className={((isShowMenu.menu_9)? ' flex ' : ' hidden ') + ' flex-wrap w-full mt-6 font-sarabun text-grey-600 text-base font-normal md:text-medium leading-6'}>
                      <ol className='w-full list-decimal  px-4'>
                        <li>สำเนาหลักฐานรับผิดชอบความเสียหายรถคู่กรณี หรือ ใบเคลม</li>
                        <li>เอกสารเรียกร้องค่าขาดประโยชน์</li>
                        <li>ต้นฉบับคู่มือจดทะเบียนรถ หรือ สำเนา พร้อมรายการจดทะเบียนเปลี่ยนแปลง และ รายการต่อภาษีปีปัจจุบัน พร้อมรับรองสำเนาถูกต้อง</li>
                        <li>สำเนากรมธรรม์ พรบ. (ถ้ามี)</li>
                        <li>สำเนากรมธรรม์ประกันภัยภาคสมัครใจ (ถ้ามี)</li>
                        <li>สำเนาบัตรประชาชนเจ้าของรถคู่กรณี พร้อมลงชื่อ รับรองสำเนาถูกต้อง</li>
                        <li>สำเนาหนังสือรับรองการจดทะเบียน พร้อมสำเนาบัตรประชาชนกรรมการ พร้อมประทับตรา (กรณีเป็นนิติบุคคล)</li>
                      </ol>
                      <span className='mt-8  font-medium'>เอกสารเพิ่มเติมกรณีมอบอำนาจจากเจ้าของรถคู่กรณีมาติดต่อ</span>
                      <ol className='w-full list-disc px-4'>
                        <li className=''>หนังสือมอบอำนาจ ติดอากรแสตมป์ 30 บาท</li>
                        <li className=''>สำเนาบัตรประจำตัวประชาชนของผู้เอาประกันภัยและผู้รับมอบอำนาจ พร้อมลงชื่อรับรองสำเนาถูกต้อง</li>
                      </ol>
                    
                    </div>
                  </div>

                </div>


                <div className='flex flex-wrap  w-full mt-6'>

                  <div data-testid='contestantDoc-loseBenefits-towCar-text' className='flex flex-wrap w-full border-b-[0.5px] border-b-grey-500 pb-6'>
                    { /* Header */ }
                    <div className='flex w-full'>
                      <div className='grow w-full'>
                        <span className='flex text-lg font-normal leading-6'>ค่าขาดผลประโยชน์ ค่ารถยก</span>
                      </div>
                      <div className='flex-none'>
                        <button data-testid='contestantDoc-loseBenefits-towCar-button' onClick={ (e)=>{ changeStateCondition(10) } } ><img src={ (isShowMenu.menu_10)? iconUp :  iconDown} alt="icon-span" /></button>
                      </div>
                    </div>
                    { /* Content */ }
                    <div className={((isShowMenu.menu_10)? ' flex ' : ' hidden ') + ' flex-wrap w-full mt-6 font-sarabun text-grey-600 text-base font-normal md:text-medium leading-6'}>
                      <ol className='w-full list-decimal  px-4'>
                        <li>สำเนาหลักฐานรับผิดชอบความเสียหายรถคู่กรณี หรือ ใบเคลม</li>
                        <li>เอกสารเรียกร้องค่าขาดประโยชน์</li>
                        <li>ใบเสนอราคา หรือ ต้นฉบับใบเสร็จค่ารถยก / บิลเงินสดค่ารถยก</li>
                        <li>ต้นฉบับคู่มือจดทะเบียนรถ หรือ สำเนา พร้อมรายการจดทะเบียนเปลี่ยนแปลง และ รายการต่อภาษีปีปัจจุบัน พร้อมรับรองสำเนาถูกต้อง</li>
                        <li>สำเนากรมธรรม์ พรบ. (ถ้ามี)</li>
                        <li>สำเนากรมธรรม์ประกันภัยภาคสมัครใจ (ถ้ามี)</li>
                        <li>สำเนาบัตรประชาชนเจ้าของรถคู่กรณี พร้อมลงชื่อ รับรองสำเนาถูกต้อง</li>
                        <li>สำเนาหนังสือรับรองการจดทะเบียน พร้อมสำเนาบัตรประชาชนกรรมการ พร้อมประทับตรา (กรณีเป็นนิติบุคคล)</li>
                      </ol>
                      <span className='mt-8  font-medium'>เอกสารเพิ่มเติมกรณีมอบอำนาจจากเจ้าของรถคู่กรณีมาติดต่อ</span>
                      <ol className='w-full list-disc px-4'>
                        <li className=''>หนังสือมอบอำนาจ ติดอากรแสตมป์ 30 บาท</li>
                        <li className=''>สำเนาบัตรประจำตัวประชาชนของผู้เอาประกันภัยและผู้รับมอบอำนาจ พร้อมลงชื่อรับรองสำเนาถูกต้อง</li>
                      </ol>
                    
                    </div>
                  </div>

                </div>



                <div className='flex flex-wrap  w-full mt-6'>

                  <div data-testid='contestantDoc-towCar-text' className='flex flex-wrap w-full border-b-[0.5px] border-b-grey-500 pb-6'>
                    { /* Header */ }
                    <div className='flex w-full'>
                      <div className='grow w-full'>
                        <span className='flex text-lg font-normal leading-6'>ค่ารถยก</span>
                      </div>
                      <div className='flex-none'>
                        <button data-testid='contestantDoc-towCar-button' onClick={ (e)=>{ changeStateCondition(11) } } ><img src={ (isShowMenu.menu_11)? iconUp :  iconDown} alt="icon-span" /></button>
                      </div>
                    </div>
                    { /* Content */ }
                    <div className={((isShowMenu.menu_11)? ' flex ' : ' hidden ') + ' flex-wrap w-full mt-6 font-sarabun text-grey-600 text-base font-normal md:text-medium leading-6'}>
                      <ol className='w-full list-decimal  px-4'>
                        <li>สำเนาหลักฐานรับผิดชอบความเสียหายรถคู่กรณี หรือ ใบเคลม</li>
                        <li>ใบเสนอราคา หรือ ต้นฉบับใบเสร็จค่ารถยก / บิลเงินสดค่ารถยก</li>
                        <li>ต้นฉบับคู่มือจดทะเบียนรถ หรือ สำเนา พร้อมรายการจดทะเบียนเปลี่ยนแปลง และ รายการต่อภาษีปีปัจจุบัน พร้อมรับรองสำเนาถูกต้อง</li>
                        <li>สำเนากรมธรรม์ พรบ. (ถ้ามี)</li>
                        <li>สำเนากรมธรรม์ประกันภัยภาคสมัครใจ (ถ้ามี)</li>
                        <li>สำเนาบัตรประชาชนเจ้าของรถคู่กรณี พร้อมลงชื่อ รับรองสำเนาถูกต้อง</li>
                        <li>สำเนาหนังสือรับรองการจดทะเบียน พร้อมสำเนาบัตรประชาชนกรรมการ พร้อมประทับตรา (กรณีเป็นนิติบุคคล)</li>
                      </ol>
                      <span className='mt-8  font-medium'>เอกสารเพิ่มเติมกรณีมอบอำนาจจากเจ้าของรถคู่กรณีมาติดต่อ</span>
                      <ol className='w-full list-disc px-4'>
                        <li className=''>หนังสือมอบอำนาจ ติดอากรแสตมป์ 30 บาท</li>
                        <li className=''>สำเนาบัตรประจำตัวประชาชนของผู้เอาประกันภัยและผู้รับมอบอำนาจ พร้อมลงชื่อรับรองสำเนาถูกต้อง</li>
                      </ol>
                    
                    </div>
                  </div>

                </div>



                <div className='flex flex-wrap  w-full mt-6'>

                  <div  data-testid='contestantDoc-tire-alloyWheels-text' className='flex flex-wrap w-full border-b-[0.5px] border-b-grey-500 pb-6'>
                    { /* Header */ }
                    <div className='flex w-full'>
                      <div className='grow w-full'>
                        <span className='flex text-lg font-normal leading-6'>ค่ายาง ค่าล้อแม็ก</span>
                      </div>
                      <div className='flex-none'>
                        <button data-testid='contestantDoc-tire-alloyWheels-button' onClick={ (e)=>{ changeStateCondition(12) } } ><img src={ (isShowMenu.menu_12)? iconUp :  iconDown} alt="icon-span" /></button>
                      </div>
                    </div>
                    { /* Content */ }
                    <div className={((isShowMenu.menu_12)? ' flex ' : ' hidden ') + ' flex-wrap w-full mt-6 font-sarabun text-grey-600 text-base font-normal md:text-medium leading-6'}>
                      <ol className='w-full list-decimal  px-4'>
                        <li>ต้นฉบับหลักฐานรับผิดชอบความเสียหายรถคู่กรณี หรือ ใบเคลม</li>
                        <li>ใบเสนอราคา หรือใบเสร็จรับเงิน (บริษัท จะพิจารณาคุมราคาตามมาตรฐาน)</li>
                        <li>ต้นฉบับคู่มือจดทะเบียนรถ หรือ สำเนา พร้อมรายการจดทะเบียนเปลี่ยนแปลง และ รายการต่อภาษีปีปัจจุบัน พร้อมรับรองสำเนาถูกต้อง</li>
                        <li>สำเนากรมธรรม์ พรบ. (ถ้ามี)</li>
                        <li>สำเนากรมธรรม์ประกันภัยภาคสมัครใจ (ถ้ามี)</li>
                        <li>สำเนาบัตรประชาชนเจ้าของรถคู่กรณี พร้อมลงชื่อ รับรองสำเนาถูกต้อง</li>
                        <li>สำเนาหนังสือรับรองการจดทะเบียน พร้อมสำเนาบัตรประชาชนกรรมการ พร้อมประทับตรา (กรณีเป็นนิติบุคคล)</li>
                      </ol>
                      <span className='mt-8  font-medium'>เอกสารเพิ่มเติมกรณีมอบอำนาจจากเจ้าของรถคู่กรณีมาติดต่อ</span>
                      <ol className='w-full list-disc px-4'>
                        <li className=''>หนังสือมอบอำนาจ ติดอากรแสตมป์ 30 บาท</li>
                        <li className=''>สำเนาบัตรประจำตัวประชาชนของผู้เอาประกันภัยและผู้รับมอบอำนาจ พร้อมลงชื่อรับรองสำเนาถูกต้อง</li>
                      </ol>
                    
                    </div>
                  </div>

                </div>              


                <div className='flex flex-wrap  w-full mt-6'>

                  <div data-testid='contestantDoc-glass-film-text' className='flex flex-wrap w-full border-b-[0.5px] border-b-grey-500 pb-6'>
                    { /* Header */ }
                    <div className='flex w-full'>
                      <div className='grow w-full'>
                        <span className='flex text-lg font-normal leading-6'>ค่ากระจก ค่าฟิล์ม</span>
                      </div>
                      <div className='flex-none'>
                        <button data-testid='contestantDoc-glass-film-button' onClick={ (e)=>{ changeStateCondition(13) } } ><img src={ (isShowMenu.menu_13)? iconUp :  iconDown} alt="icon-span" /></button>
                      </div>
                    </div>
                    { /* Content */ }
                    <div className={((isShowMenu.menu_13)? ' flex ' : ' hidden ') + ' flex-wrap w-full mt-6 font-sarabun text-grey-600 text-base font-normal md:text-medium leading-6'}>
                      <ol className='w-full list-decimal  px-4'>
                        <li>ต้นฉบับหลักฐานรับผิดชอบความเสียหายรถคู่กรณี หรือ ใบเคลม</li>
                        <li>ใบเสนอราคา หรือใบเสร็จรับเงิน (บริษัท จะพิจารณาคุมราคาตามมาตรฐาน)</li>
                        <li>ต้นฉบับคู่มือจดทะเบียนรถ หรือ สำเนา พร้อมรายการจดทะเบียนเปลี่ยนแปลง และ รายการต่อภาษีปีปัจจุบัน พร้อมรับรองสำเนาถูกต้อง</li>
                        <li>สำเนากรมธรรม์ พรบ. (ถ้ามี)</li>
                        <li>สำเนากรมธรรม์ประกันภัยภาคสมัครใจ (ถ้ามี)</li>
                        <li>สำเนาบัตรประชาชนเจ้าของรถคู่กรณี พร้อมลงชื่อ รับรองสำเนาถูกต้อง</li>
                        <li>สำเนาหนังสือรับรองการจดทะเบียน พร้อมสำเนาบัตรประชาชนกรรมการ พร้อมประทับตรา (กรณีเป็นนิติบุคคล)</li>
                      </ol>
                      <span className='mt-8  font-medium'>เอกสารเพิ่มเติมกรณีมอบอำนาจจากเจ้าของรถคู่กรณีมาติดต่อ</span>
                      <ol className='w-full list-disc px-4'>
                        <li className=''>หนังสือมอบอำนาจ ติดอากรแสตมป์ 30 บาท</li>
                        <li className=''>สำเนาบัตรประจำตัวประชาชนของผู้เอาประกันภัยและผู้รับมอบอำนาจ พร้อมลงชื่อรับรองสำเนาถูกต้อง</li>
                      </ol>
                    
                    </div>
                  </div>

                </div>    

                <div className='flex flex-wrap w-full mt-10 md:mt-10'>
                  <span className='flex text-xl md:text-2xl font-medium leading-7 md:leading-8'>ระยะเวลาในการชดใช้ค่าสินไหมทดแทนรถยนต์​</span>
                </div>

                <div className='flex flex-wrap  w-full mt-6'>

                  <div data-testid='controlPrice-text' className='flex flex-wrap w-full border-b-[0.5px] border-b-grey-500 pb-6'>
                    { /* Header */ }
                    <div className='flex w-full'>
                      <div className='grow w-full'>
                        <span className='flex text-lg font-normal leading-6'>เงื่อนไขการชดใช้ค่าสินไหม</span>
                      </div>
                      <div className='flex-none'>
                        <button data-testid='controlPrice-button' onClick={ (e)=>{ changeStateCondition(14) } } ><img src={ (isShowMenu.menu_14)? iconUp :  iconDown} alt="icon-span" /></button>
                      </div>
                    </div>
                    { /* Content */ }
                    <div className={((isShowMenu.menu_14)? ' flex ' : ' hidden ') + ' flex-wrap w-full mt-6 font-sarabun text-grey-600 text-base font-normal md:text-medium leading-6'}>
                      <ol className='w-full list-decimal  px-4'>
                        <li>กรณีเป็นค่าซ่อมรถประกันเมื่อรถยนต์คันเอาประกันภัยซ่อมเสร็จเรียบร้อยแล้ว และผู้เอาประกันภัยมีการสำรองจ่ายค่าซ่อมรถยนต์เมื่อผู้เอาประกันภัยนำรถคันเอาประกันภัยมาให้บริษัทตรวจสอบผลการจัดซ่อมแล้วบริษัทจะชดใช้ค่าสินไหมคืนผู้เอาประกันภายใน 15 วัน นับจากวันที่ผู้เอาประกันนำเอกสารประกอบการเบิกค่าสินไหมมาให้บริษัทครบ</li>
                        <li>กรณีเป็นค่าซ่อมรถคู่กรณี บริษัทจะแจ้งผลการพิจารณาให้ผู้เสียหายทราบภายในระยะเวลา 15 วันนับจากวันที่ผู้เสียหายนำรถยนต์คันเสียหายมาติดต่อ และหลังจากมีการตกลงค่าซ่อมเป็นที่ยุติแล้ว บริษัทจะชดใช้ค่าสินไหมภายใน 15 วัน นับจากวันที่ผู้เสียหายนำเอกสารประกอบการเบิกค่าสินไหมมาให้บริษัทครบ</li>
                      </ol>
                    
                    </div>
                  </div>

                </div>




                <div className='flex flex-wrap w-full mt-10 md:mt-10'>
                  <span className='flex text-xl md:text-2xl font-medium leading-7 md:leading-8'>ช่องทางการติดต่อ และช่องทางส่งเอกสารอื่นๆ</span>
                </div>

                <div className='flex flex-wrap  w-full mt-6'>

                  <div data-testid='contact-CS-text' className='flex flex-wrap w-full border-b-[0.5px] border-b-grey-500 pb-6'>
                    { /* Header */ }
                    <div className='flex w-full'>
                      <div className='grow w-full'>
                        <span className='flex text-lg font-normal leading-6'>ฝ่ายลูกค้าสัมพันธ์</span>
                      </div>
                      <div className='flex-none'>
                        <button data-testid='customerSupport-contact-button' onClick={ (e)=>{ changeStateCondition(15) } } ><img src={ (isShowMenu.menu_15)? iconUp :  iconDown} alt="icon-span" /></button>
                      </div>
                    </div>
                    { /* Content */ }
                    <div className={((isShowMenu.menu_15)? ' flex ' : ' hidden ') + '  flex-wrap w-full mt-6 font-sarabun text-grey-600 text-base font-normal md:text-medium leading-6'}>
                      <ol className='w-full list-decimal  px-4'>
                        <li>โทรศัพท์ : 1231 กด 4</li>
                      </ol>
                    
                    </div>
                  </div>

                </div>


                <div className='flex flex-wrap  w-full mt-6'>

                  <div  data-testid='contact-other-text' className='flex flex-wrap w-full border-b-[0.5px] border-b-grey-500 pb-6'>
                    { /* Header */ }
                    <div className='flex w-full'>
                      <div className='grow w-full'>
                        <span className='flex text-lg font-normal  leading-6'>ช่องทางส่งเอกสารอื่นๆ</span>
                      </div>
                      <div className='flex-none'>
                        <button data-testid='other-contact-button' onClick={ (e)=>{ changeStateCondition(16) } } ><img src={ (isShowMenu.menu_16)? iconUp :  iconDown} alt="icon-span" /></button>
                      </div>
                    </div>
                    { /* Content */ }
                    <div className={((isShowMenu.menu_16)? ' flex ' : ' hidden ') + '  flex-wrap w-full mt-6 font-sarabun text-grey-600 text-base font-normal md:text-medium leading-6'}>
                      <ol className='w-full list-decimal  px-4'>
                        <li>บริษัท ประกันภัยไทยวิวัฒน์ จำกัด (มหาชน) ชั้น 8 เลขที่ 71 ถนนดินแดง แขวงสามเสนใน เขตพญาไท กรุงเทพฯ 10400</li>
                      </ol>
                    
                    </div>
                  </div>

                </div>

              </div>

          </div>
        </div>


        { /* Contact us */}
        {/* <div className='flex flex-wrap w-full lg:w-1092 lg:mx-auto bg-white px-4 py-16 md:py-[96px]'>
            <div className='flex flex-wrap w-full justify-center'>
              <div className='flex flex-wrap w-full justify-center'>
                <span className='flex md:hidden text-2xl md:text-[32px] font-medium leading-8 md:leading-[44px] text-center'>หากคุณต้องการให้เรา<br/>ติดต่อกลับ</span>
                <span className='hidden md:flex text-2xl md:text-[32px] font-medium leading-8 md:leading-[44px] text-center'>หากคุณต้องการให้เราติดต่อกลับ</span>
              </div>
              <div className='flex flex-wrap w-full justify-center mt-[16px]'>
                <span className='text-lg leading-6 text-grey-600 text-center'>กรอกรายละเอียดปัญหาที่คุณพบเจอเกี่ยวกับการเรียกร้องค่าสินไหมทดแทน</span>
              </div>

            </div>
            <div className=' flex-wrap w-full md:w-1/2'>
              
          
              <div className='flex w-full mt-16'>
                <div className='flex-none'>
                  <img src={iconTel} alt="icon-tel" className='w-[24px] h-[24px]' />
                </div>
                <div data-testid='contact-phoneNumber-text' className='grow flex flex-wrap w-full pl-[16px]'>
                  <div className='flex w-full'>
                    <span className='text-base font-medium leading-5 text-black'>เบอร์โทรศัพท์</span>
                  </div>
                  <div className='flex w-full mt-2'>
                    <span className='text-sm font-normal leading-5 text-grey-600'>จันทร์ - ศุกร์ ตั้งแต่ 8:30 น. - 17:30 น.</span>
                  </div>
                  <div className='flex  w-full mt-4'>
                    <span className='text-sm font-normal leading-5 text-black'>1231 กด 4</span>
                  </div>
                </div>
              </div>

              <div className='flex w-full mt-10'>
                <div className='flex-none'>
                  <img src={iconEmail} alt="icon-email"  className='w-[24px] h-[24px]' />
                </div>
                <div data-testid='contact-email-text' className='grow flex flex-wrap w-full pl-[16px]'>
                  <div className='flex w-full'>
                    <span className='text-base font-medium leading-5 text-black'>อีเมล</span>
                  </div>
                  <div className='flex w-full mt-2'>
                    <span className='text-sm font-normal leading-5 text-grey-600'>เรามีทีมที่คอยรับเรื่องที่ช่วยเหลือคุณ</span>
                  </div>
                  <div className='flex  w-full mt-4'>
                    <span className='text-sm font-normal leading-5 text-black'>info@thaivivat.co.th</span>
                  </div>
                </div>
              </div>

              <div className='flex w-full mt-10'>
                <div className='flex-none'>
                  <img src={iconLocation} alt="icon-location"  className='w-[24px] h-[24px]' />
                </div>
                <div data-testid='contact-address-text' className='grow flex flex-wrap w-full pl-[16px]'>
                  <div className='flex w-full'>
                    <span className='text-base font-medium leading-5 text-black'>ที่อยู่</span>
                  </div>
                  <div className='flex w-full mt-2'>
                    <span className='text-sm font-normal leading-5 text-grey-600'>ที่อยู่สำหรับการส่งเอกสาร</span>
                  </div>
                  <div className='flex  w-full mt-4'>
                    <span className='text-sm font-normal leading-5 text-black'>บริษัท ประกันภัยไทยวิวัฒน์ จำกัด (มหาชน) ชั้น 8 เลขที่ 71 ถนนดินแดง แขวงสามเสนใน เขตพญาไท กรุงเทพฯ 10400</span>
                  </div>
                </div>
              </div>

            </div>

            <div className=' flex-wrap w-full md:w-1/2 mt-16 md:pl-10'>
              <div className='flex flex-wrap w-full'>
                <div className=' flex-wrap w-full'>
                  <span className='text-sm font-medium leading-5 text-black'>ชื่อผู้ติดต่อ<span className='text-red-500'>*</span></span>
                </div>
                <div className=' flex-wrap w-full'>
                  <input data-testid='dropLead-name-input' value={customerName} onChange={ (e)=> { onChangeText( e, setCustomerName )  }} type={'search'} className={'w-full h-[48px] mt-1  font-prompt text-md border py-2 px-4 rounded-lg focus:outline-none focus:border-green-500 focus:border-1 focus:box-border focus:shadow-normal focus:shadow-green-400 ' + ( (false)? ' border-red-500 ' : ' border-grey-300 ' )} placeholder='ชื่อ - นามสกุล' />
                </div>  
              </div>
              <div className='flex flex-wrap w-full mt-6'>
                <div className=' flex-wrap w-full'>
                  <span className='text-sm font-medium leading-5 text-black'>อีเมล </span><span className='text-grey-500 font-normal'>(ถ้ามี)</span>
                </div>
                <div className=' flex-wrap w-full'>
                  <input data-testid='dropLead-email-input' value={customerEmail} onChange={ (e)=> { onChangeEmail( e, setCustomerEmail )  }} type={'search'} className={'w-full h-[48px] mt-1  font-prompt text-md border py-2 px-4 rounded-lg focus:outline-none focus:border-green-500 focus:border-1 focus:box-border focus:shadow-normal focus:shadow-green-400 ' + ( (false)? ' border-red-500 ' : ' border-grey-300 ' )} placeholder='your@company.com' />
                </div>  
              </div>
              <div className='flex flex-wrap w-full mt-6'>
                <div className=' flex-wrap w-full'>
                  <span className='text-sm font-medium leading-5 text-black'>เบอร์โทรศัพท์<span className='text-red-500'>*</span></span>
                </div>
                <div className=' flex-wrap w-full'>
                  <input data-testid='dropLead-contactNo-input' value={customerTel} onChange={ (e)=> { 
                    onChangeNumber( e, setCustomerTel )  
                    }} type={'search'} className={'w-full h-[48px] mt-1  font-prompt text-md border py-2 px-4 rounded-lg focus:outline-none focus:border-green-500 focus:border-1 focus:box-border focus:shadow-normal focus:shadow-green-400 ' + ( (false)? ' border-red-500 ' : ' border-grey-300 ' )}  placeholder='000 000 0000' />
                </div>  
              </div>
              <div className='flex flex-wrap w-full mt-6'>
                <div className=' flex-wrap w-full'>
                  <label for="customer-message" className='text-sm font-medium leading-5 text-black'>ข้อความ<span className='text-red-500'>*</span></label>
                </div>

                <textarea data-testid='dropLead-message-input' id="customer-message" rows={5} value={customerMessage} onChange={ (e)=> { onChangeText( e, setCustomerMessage )  }} type={'search'} className={'w-full h-[104px] mt-1  font-prompt text-md border py-2 px-4 rounded-lg focus:outline-none focus:border-green-500 focus:border-1 focus:box-border focus:shadow-normal focus:shadow-green-400 ' + ( (false)? ' border-red-500 ' : ' border-grey-300 ' )}  />

              </div>

              <button 
                  data-testid='dropLead-submit-button'
                  onClick={submit}
                  disabled={!isValid}
                  className={'w-full lg:px-4 text-base leading-6 h-[48px]  mt-6 md:h-12 font-medium rounded-lg border-radius-other  '+ ( (!isValid)? ' bg-grey-100 text-white  ' : ' bg-green-500 text-white ')}>
                    ส่งข้อความ
              </button>
            </div>
        </div> */}

        <FooterComponent></FooterComponent>

      </div>
      {/* {
        isShowAlertEmail ?

        <ModalAlertSendEmailSuccess 
          confirmClick={confirmClick}
          isSuccess={isEmailSuccess}
        />
        :
        null
      } */}

      
  </div>
  )
}

export default MainPage;